<template>
  <NavigationComponent>
    <Standardfolie title="Dokumentation">
      <p>
        Viel hilfreiche Infos finden sich auch in der
        <a href="https://vuejs.org/v2/guide/">Vue Dokumentation</a> und in der
        <a href="https://vuetifyjs.com/en/introduction/guide/">Vuetify Doku</a>.
      </p>
      <p>Vielen Dank für eure Aufmerksamkeit!</p>
    </Standardfolie>
  </NavigationComponent>
</template>

<script>
import NavigationComponent from "../components/NavigationComponent";
import Standardfolie from "../components/Standardfolie";
export default {
  name: "Dokumentation",
  components: { Standardfolie, NavigationComponent }
};
</script>

<style scoped></style>
